import React from 'react'
import Modal, { PrevButton, CloseButton } from '@jarvis.oddle/core/components/Modal'
import Card from '@jarvis.oddle/core/components/Card'
import { H4, P } from '@jarvis.oddle/core/components/Typo'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import useAppSelector from 'src/hooks/useAppSelector'
import { selectOrder } from 'src/redux/order'
import ProceedToCheckoutButton from './ProceedToCheckoutButton'
import { makeControlledModal } from 'src/decorators/ModalController'

const CheckoutPromotionSummaryModal = ({
  modal,
  goToPreviousModal
}: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  goToPreviousModal: () => void
}) => {
  const { t } = React.useContext(TranslationContext)
  const selectedPromotions = useAppSelector(selectOrder).selectedPromotions

  return (
    <Modal {...modal} slideInAnimation='bottom'>
      <Modal.FlexContainer height={500}>
        <Modal.Header>
          <PrevButton onClick={goToPreviousModal} />
          <H4 normalised bold>{t('Promotions')}</H4>
          <CloseButton onClick={modal.onClose} />
        </Modal.Header>
        <Modal.Body>
          <Modal.Section>
            {selectedPromotions.data?.map((promotion) => (
              <Card marginBottom={marginSizes.small}>
                <P bold normalised>{promotion.name}</P>
                <P normalised>{promotion.description}</P>
              </Card>
            ))}
          </Modal.Section>
        </Modal.Body>
        <Modal.Footer>
          <ProceedToCheckoutButton
            closeCurrentModal={modal.onClose}
            promotions={selectedPromotions.data} />
        </Modal.Footer>
      </Modal.FlexContainer>
    </Modal>
  )
}

export default makeControlledModal(CheckoutPromotionSummaryModal, 'CheckoutPromotionSummaryModal')
